document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-open-modal').forEach(btn => {
    const modal = document.getElementById(btn.dataset.modalId);
    if (!modal) return;

    const video = modal.querySelector('video');
    const close = modal.querySelector('.modal__close');
    const backdrop = modal.querySelector('.modal__backdrop');

    btn.addEventListener('click', () => {
      modal.classList.remove('hidden');
      video?.play();
    });

    function hide() {
      video?.pause();
      video.currentTime = 0;
      modal.classList.add('hidden');
    }

    close.addEventListener('click', hide);
    backdrop.addEventListener('click', hide);
  });
});
